/*
  The purpose of the LEARNING MAP is to contain the logic to display a Verlet enabled map
  With mouse navigation and not much else.

  It is different from the meta-map because it does not handle the entire
  meta module structure on its own, it just displays an array of resources.
  It does absolutely no post-processing on the structure of the resources.
  something else has to explicitely tell this what to show

  It also doesn't provide functions for the side and bottom panels like the meta map does.
*/

angular.module('mtic.components.modules.gr78')
.directive('gr78LearningMap', function(
  DEV_VARIABLES,
  GR78_ASSET_URL,
  $q,
  $timeout,
  TIMING_CONSTANTS,
  $log,
  $window,
  gr78MapItemFactory,
  VerletSystemService,
  TeacherDataService,
  learningMapUtil,
  PIXI,
  EventManager,
  language
) {

  return {

    templateUrl: 'template.html',
    scope: {
      moduleMapData: "="
    },
    link: function(scope) {

      // event manager for coordination with rest of application
      var eventManager = new EventManager('gr78LearningMap', scope);
      var verlet_system = new VerletSystemService();
      ///////////////////
      // PRIVATE VARS //
      /////////////////

      var canvas_el = null;
      var app = null;
      var renderer = null;
      var drag_info = null;
      var canvasDimensions = null;
      var scale = null;
      var stage = null;
      var modules_container = null;
      var container = null;
      var lines_graphic = null;
      var selection_graphic = null;
      var items = [];
      var isMobile = (navigator.userAgent.match(/Android/i) || /iPad|iPhone|iPod/.test(navigator.userAgent));

      var img_asset_paths = [
        GR78_ASSET_URL + "symlink.png",
        GR78_ASSET_URL + "item_blue_0.png",
        GR78_ASSET_URL + "item_blue_1.png",
        GR78_ASSET_URL + "item_red_0.png",
        GR78_ASSET_URL + "item_red_1.png",
        GR78_ASSET_URL + "item_red_2.png",
        GR78_ASSET_URL + "item_red_3.png",
        GR78_ASSET_URL + "item_black_0.png",
        GR78_ASSET_URL + "item_black_1.png",
        GR78_ASSET_URL + "item_black_2.png",
        GR78_ASSET_URL + "item_black_3.png",
        GR78_ASSET_URL + "item_blue_locked.png",
        GR78_ASSET_URL + "item_red_locked.png",
        GR78_ASSET_URL + "item_black_locked.png",
        GR78_ASSET_URL + "assessment.png",
        GR78_ASSET_URL + "assessment_complete.png",
        GR78_ASSET_URL + "selection.png"
      ]
      var focus_item = null;
      var selection = null;

      /////////////
      // CONSTRUCTOR
      /////////////

      function init() {
        // retrieve template element references
        canvas_el = document.getElementById('canvas');
        if (!canvas_el) {
          return;
        }

        app = new PIXI.Application(300, 300, {
          autoResize: true,
          backgroundColor: 0xdee9fc,
          antialias: true,
          view: canvas_el
        });

        renderer = app.renderer;
        scale = 0.8;
        items = [];
        drag_info = learningMapUtil.getDragInfoSettings();

        canvasDimensions = {
          width: window.innerWidth,
          height: window.innerHeight - 50,
        }

        stage = app.stage;
        stage.interactive = true;

        window.addEventListener("resize", onResize);
        onResize();
        renderer.render(stage);

        container = new PIXI.Sprite();
        container.interactive = true;
        container.scale.set(scale, scale);
        container.x = renderer.width / 2;
        container.y = renderer.height / 2;
        stage.addChildAt(container, 0);

        lines_graphic = new PIXI.Graphics();
        container.addChild(lines_graphic);

        app.ticker.add(update);

        canvas_el.addEventListener('DOMMouseScroll', handleScroll, false); // for Firefox
        canvas_el.addEventListener('mousewheel', handleScroll, false); // for everyone else
        canvas_el.addEventListener('pointerdown', handleDoubleClick, false);

        stage.on('pointerdown', function(e) {
          drag_info.dragging = true;
          focus_item = null;
          drag_info.velocity = {
            x: 0,
            y: 0
          };
          drag_info.start_drag_pos = {
            x: container.x,
            y: container.y
          };
          drag_info.start_drag_mouse_pos = {
            x: renderer.plugins.interaction.eventData.data.global.x,
            y: renderer.plugins.interaction.eventData.data.global.y
          };
          drag_info.last_mouse_pos = {
            x: drag_info.start_drag_mouse_pos.x,
            y: drag_info.start_drag_mouse_pos.y
          };
        });
        stage.on('pointerup', function(e) {
          if (window.DEBUG_TOUCH){ $log.log('g78_lmap pointerup ; ', JSON.stringify(drag_info)); }
          drag_info.dragging = false;
        });

        if (window.DEBUG_TOUCH){ $log.log('g78_lmap pointerdown ; ', JSON.stringify(drag_info)); }

        return loadAssets().then(function() {
          $log.debug('[[gr78MetaMap]] loadAssets.then');
          return;
        }).catch(function(err) {
          $log.error('[[gr78MetaMap]] loadAssets.then', err.message)
          $log.debug(err.stack)
        });

      }

      eventManager.listen('module:select:resource', function(e, data) {
        var mapResource = getItemBySlug(data.slug)
        if (mapResource === null) {
          return;
        }
        if (selection === mapResource) {
          eventManager.broadcast('module:open:resource', data);
          return;
        }
        selection = mapResource;
        mapResource.sprite.addChildAt(selection_graphic, 0);
        selection_graphic.scale.set(0);
      });

      eventManager.listen('module:center:resource', function(e, data) {
        focus_item = getItemBySlug(data.slug);
      });

      eventManager.listen('module:stop:pan', function() {
        focus_item = null;
      });

      eventManager.listen('resource:highlight:agenda', function(e, data) {
        $log.debug(data);
        var i, n, item;
        for (i = 0; i < items.length; i++)
        {
          item = items[i];
          item.hideAgendaHighlight();
          for (n = 0; n < data.length; n ++)
          {
            if (item.slug === data[n].slug)
            {
              item.showAgendaHighlight();
              break;
            }
          }
        }
      });

      eventManager.listen('module:change:submodule', function(e, data) {
        $timeout(function() {
          verlet_system.deactivateAllBodies(true);
          $log.debug(data)
          $log.debug(scope);
          for (var i = 0; i < scope.moduleMapData.resources.length; i++) {
            if (scope.moduleMapData.resources[i].slug === data) {
              scope.currentActiveSubModule = scope.moduleMapData.resources[i];
              var resource = scope.moduleMapData.resources[i];
              for (var n = 0; n < resource.children.length; n++) {

                if (resource.children[n].slug === 'mtic_g78_m1_beaker' || resource.children[n].slug === 'mtic_g78_m1_prop_table_b')
                {
                  continue;
                }

                verlet_system.activateBody(resource.children[n].slug, true);
              }
              break;
            }
          }
        }, TIMING_CONSTANTS.INSTANT);
      })
      /////////////
      // METHODS
      /////////////

      //Mousewheel zoom/in out at cursor position (like google maps)
      var handleScroll = function(evt) {
        if (!evt) {
          return;
        }
        //normalize the wheel delta because browsers send all sorts of values
        var direction = (evt.detail < 0 || evt.wheelDelta > 0) ? 1 : -1;

        //store the current scale so we can calculate the difference
        var start_scale = scale;
        scale = Math.max(Math.min(1.5, scale + direction / 15), 0.25);
        var diff = scale - start_scale;
        container.scale.set(scale, scale);

        //multiply the local mouse position in the resized map by the change in scale and TRANSLATE
        var pos = renderer.plugins.interaction.eventData.data.getLocalPosition(container);
        container.position.x -= diff * pos.x;
        container.position.y -= diff * pos.y;

        evt.preventDefault();
        return false;
      };

      var handleDoubleClick = function(e) {
        e.preventDefault();
        return false;
      };

      var initMapDraw = function(moduleMapData) {
        if (!moduleMapData) {
          return;
        }
        var combinedResourceMap = {};

        _.forEach(moduleMapData, function(someItem) {
          combinedResourceMap[someItem.slug] = someItem;
          loadChildren(someItem);
        })

        _.each(combinedResourceMap, function(resource) {
          createItem(resource, null);
        })
        _.forEach(items, function(item) {
          if (!item.locked) {
            item.unlock();
          }
        })
      };


      //This loops to control things that should update every frame
      var update = function() {
        if (selection_graphic !== null) {
          //Rotate it a little bit
          selection_graphic.rotation = (selection_graphic.rotation - 0.015) % (Math.PI * 2);

          //Use UNIX time to scale the graphic with a sin function
          //Lerp towards the desired scale rather than directly setting it (so we can scale it to zero in other places and have it 'pop up')
          selection_graphic.scale.set((selection_graphic.scale.x * 9 + (0.8 + Math.sin(Date.now() / 500.0) / 10)) / 10);
        }

        //update the verlet force directed graph that positions the map items in that big jiggly web
        verlet_system.update();
        //   drawMapLines();
        if (drag_info.dragging) {
          var mouse_pos = {
            x: renderer.plugins.interaction.eventData.data.global.x,
            y: renderer.plugins.interaction.eventData.data.global.y
          }
          if (isNaN(mouse_pos.x) || isNaN(mouse_pos.y) || (isMobile && renderer.plugins.interaction.eventData.data.identifier === 'MOUSE')) {
            mouse_pos.x = drag_info.last_mouse_pos.x;
            mouse_pos.y = drag_info.last_mouse_pos.y;
          }

          //Move the map based on the mouse position
          container.position.x = drag_info.start_drag_pos.x - (drag_info.start_drag_mouse_pos.x - mouse_pos.x);
          container.position.y = drag_info.start_drag_pos.y - (drag_info.start_drag_mouse_pos.y - mouse_pos.y);

          //vector of mouse movement since last update frame
          var delta_pos = {
            x: drag_info.last_mouse_pos.x - mouse_pos.x,
            y: drag_info.last_mouse_pos.y - mouse_pos.y
          };

          //add the mouse movement vector to the map movement velocity (inertia)
          drag_info.velocity = {
            x: (drag_info.velocity.x * 4 + delta_pos.x) / 5,
            y: (drag_info.velocity.y * 4 + delta_pos.y) / 5
          };

          //store the current position in the last_mouse_pos to calculate the movement vector next frame
          drag_info.last_mouse_pos = {
            x: mouse_pos.x,
            y: mouse_pos.y
          };

        } else {
          //If they're not dragging, move the map based on its inertia and damp the inertia
          container.position.x -= drag_info.velocity.x;
          container.position.y -= drag_info.velocity.y;
          drag_info.velocity.x *= 0.84;
          drag_info.velocity.y *= 0.84;
        }
        focusItemTicker();

        lines_graphic.clear();
        lines_graphic.lineStyle(8, 0xCCCCDD, 1);
        var segments = verlet_system.getLineSegments();
        var i;
        for (i = 0; i < segments.solid.length; i++) {
          lines_graphic.moveTo(segments.solid[i].start.x, segments.solid[i].start.y);
          lines_graphic.lineTo(segments.solid[i].end.x, segments.solid[i].end.y);
        }
        lines_graphic.beginFill(0xFF0000, 1);
        for (i = 0; i < segments.dash.length; i++) {
          lines_graphic.drawCircle(segments.dash[i].x, segments.dash[i].y, 1.5);
        }
        lines_graphic.endFill();

        if (window.DEBUG_TOUCH){ $log.log('g78_lmap update ; ', JSON.stringify(drag_info)); }
      };

      /**
       *Expand a subgroup to reveal child items
       *slug is a unique String that identifies the group MapItem
       **/
      var expandGroup = function(slug) {
        if(DEV_VARIABLES.RESOURCES.LOCK_THESE.indexOf(slug) > -1) {
          return;
        }
        //Cancel this mouse event if they were dragging more than 10 pixels
        if (drag_info.dragging) {
          if (Math.pow(container.x - drag_info.start_drag_pos.x, 2) + Math.pow(container.y - drag_info.start_drag_pos.y, 2) > 100) {
            return;
          }
        }

        if (verlet_system.deactivateBody(slug, true)) {
          var group = getItemBySlug(slug);
          //position all of the sub items so that they appear from where the clicked group icon is
          for (var i = 0; i < items.length; i++) {
            if (items[i].parentItem === group) {
              items[i].sprite.position.x = group.sprite.position.x;
              items[i].sprite.position.y = group.sprite.position.y;
              verlet_system.activateBody(items[i].slug, true);
            }
          }
        }
      }

      /**
       *Collapse a subgroup to hide child items
       *slug is a unique String that identifies the group MapItem
       **/
      var collapseGroup = function(slug) {
        var group = getItemBySlug(slug);
        if (group.isExpanded === true) {
          toggleGroupExpanded(group);
        }
      }

      /**
       *Toggle the expand/collapse of a given item group
       *group is a MapItem
       **/
      var toggleGroupExpanded = function(group) {
        group.isExpanded = !group.isExpanded;
        //    baseVerletSystem.hookUpConstraints();
      }

      //If focus item is defined, pan towards it
      var focusItemTicker = function() {
        if (focus_item === null) {
          return;
        }
        var abs_pos = container.toGlobal(focus_item.sprite.position);
        container.x += -(abs_pos.x - 125 - app.renderer.width / 2) / 10;
        container.y += -(abs_pos.y + 80 - app.renderer.height / 2) / 10;
      }

      /**
       *Return a MapItem whose slug matches the passed slug
       *Returns null if no MapItem can be found
       */
      var getItemBySlug = function(slug) {
        for (var i = 0; i < items.length; i++) {
          if (items[i].slug === slug) {
            return items[i];
          }
        }
        return null;
      }

      var getItemById = function(id) {
        for (var i = 0; i < items.length; i++) {
          if (items[i].id === id) {
            return items[i];
          }
        }
        return null;
      }

      var onResize = function() {
        canvasDimensions = {
          width: window.innerWidth,
          height: window.innerHeight - 52
        }
        stage.hitArea = new PIXI.Rectangle(0, 0, canvasDimensions.width, canvasDimensions.height);
        if (!document.getElementById('canvas')) {
          return;
        }
        document.getElementById('canvas').width = canvasDimensions.width;
        document.getElementById('canvas').height = canvasDimensions.height;

        renderer.resize(canvasDimensions.width, canvasDimensions.height);
      };

      // scope.$watch("moduleMapData", function (moduleMapData) {

      //this is what runs to initialize the map
      var loadAssets = function() {
        $log.debug('[[gr78MetaMap]] loadAssets')
        return $q(function(resolve, reject) {
          try {
            if (!PIXI_gr78_Load_Cache) {
              PIXI.loader.reset();
              PIXI.loader
                .add(img_asset_paths)
                .load(function() {
                  // $log.debug('loaded resources', PIXI.loader.resources)
                  PIXI_gr78_Load_Cache = true;
                  initMap(resolve);
                })
            } else {
              initMap(resolve);
            }
          } catch (err) {
            $log.error('[[gr78MetaMap]]', err)
            reject(err);
          }
        })
      }

      var initMap = function(resolve) {
        initMapDraw(scope.moduleMapData);

        $timeout(function() {
          verlet_system.deactivateAllBodies(true);
          for (var i = 0; i < scope.moduleMapData.length; i++) {
            if (scope.moduleMapData[i].slug.indexOf('mtic_g78_m2_sum') === -1)
            {
              verlet_system.activateBody(scope.moduleMapData[i].slug, true);
            }
          }
        }, TIMING_CONSTANTS.INSTANT)
        if (selection_graphic === null){
          selection_graphic = new PIXI.Sprite(PIXI.loader.resources[GR78_ASSET_URL + 'selection.png'].texture);
          selection_graphic.anchor.set(0.5, 0.5);
          selection_graphic.scale.set(0.75, 0.75);
          selection_graphic.interactive = false;
          selection_graphic.hitArea = new PIXI.Rectangle(0, 0, 0, 0);
        }

        resolve();
      }

      var loadChildren = function(someItem) {
        someItem.childResourcemap = [];
        if (someItem.children === undefined) {
          return;
        }
        if (someItem.children.length > 0) {
          _.forEach(someItem.children, function(childItem) {
            someItem.childResourcemap[childItem.slug] = childItem;
            loadChildren(childItem);
          });
        }
      }

      var createItem = function(resource, parentItem, start_hidden) {
        if (resource.display && !resource.display.position) {
          if (resource.children && resource.children.length > 0) {
            _.forEach(resource.children, function(childItem) {
              createItem(childItem, parentItem);
            });
          }
          return;
        }

        if (verlet_system.getBody(resource.slug) !== undefined) {
          return;
        }
        var displayItem;

        //Add this to the map logic array of items
        items.push(displayItem = new gr78MapItemFactory.createMapItem(resource, eventManager));

        //create a VerletBody for the item
        displayItem.parentItem = parentItem;

        container.addChild(displayItem.sprite);

        if (TeacherDataService.isTeacherModuleView){
          resource.locked = false;
        }

        var children = [];
        //Build the child items
        _.forEach(resource.children, function(childItem) {
          children.push(createItem(childItem, displayItem, true));
        });

        //If this has children, it is a Group Item (An Item that is not a lesson itself, but a container for a group of lessons)
        //So we create its list of unlocked_by based on the items in the group
        //Find any children whose unlocked_by is not contained in the group (points to an item outside of the group)
        //And add it to the unlocked_by of the group
        if (displayItem.unlocked_by && displayItem.unlocked_by.length === 0) {
          for (var i = 0; i < children.length; i++) {
            for (var n = 0; n < children[i].unlocked_by.length; n++) {
              var is_inner = true;
              for (var p = 0; p < children.length; p++) {
                //This is pointing from an item in the group to another item in the group
                if (children[i].unlocked_by[n] === children[p].slug) {
                  is_inner = false;
                }
              }
              //This isn't pointing to any item inside the group.... so it is pointing to an item outside the group
              if (is_inner) {
                displayItem.unlocked_by.push(children[i].unlocked_by[n]);
              }
            }
          }
        }

        displayItem.verletBody = verlet_system.createBody(resource.slug, displayItem.sprite, resource.unlocked_by, !resource.complete); //new VerletBody(displayItem);
        if (start_hidden) {
          displayItem.sprite.visible = false;
          verlet_system.deactivateBody(resource.slug);
        }

        //Add the expandGroup listener to the item
        if (resource.resource_type === "group") {
          displayItem.setDelegate(expandGroup.bind(this));
          displayItem.isExpanded = false;
        }
        return displayItem;
      }

      this.destroy = function() {
        $log.debug(" ==== DESTROYING MODULE MAP!!! ==== ");
        if (canvas_el) {
          canvas_el.removeEventListener('DOMMouseScroll', handleScroll);
          canvas_el.removeEventListener('mousewheel', handleScroll);
          canvas_el.removeEventListener('pointerdown', handleDoubleClick);
        }
        stage.removeChildren();
        container.removeChildren();
        app.destroy();
        window.removeEventListener("resize", onResize);
        EXISTS = false;
      }.bind(this)

      scope.$on('$destroy', function() {
        this.destroy();
      }.bind(this));

      scope.$watch("moduleMapData", function(moduleMapData) {
        if (!moduleMapData) {

          return;
        }
        if (!EXISTS)
        {
        EXISTS = true;
          init();
        } else {
          initMap(function(){});
        }
      })
    }
  }
});

var PIXI_gr78_Load_Cache;
var EXISTS;
